import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ShieldAlert } from "lucide-react";

export default function Forbidden() {
  return (
    <div
      data-testid="forbidden-page"
      className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4"
    >
      <ShieldAlert className="h-12 w-12 text-amber-500 mb-4" />
      <h1 className="text-2xl font-semibold">Access denied</h1>
      <p className="text-sm text-slate-500 mt-2 max-w-md">
        Your account doesn&apos;t have the role required to view this page. Ask an admin to grant
        access, or head back to your dashboard.
      </p>
      <Button asChild className="mt-6">
        <Link to="/" data-testid="forbidden-home-btn">Back to dashboard</Link>
      </Button>
    </div>
  );
}
